import React, { useState } from 'react'
import ButtonSelector from '../../common/button-selector'
import { Button } from 'react-bootstrap'
import useCurrentUser from '../../../hooks/use-current-user'
import PaginatedList from '../paginated-list'
import Unauthorized from '../../common/unauthorized'

const ReportsScreen = () => {

    const { isAdmin, isFacilitator } = useCurrentUser()

    if (!isAdmin && !isFacilitator) {
        return (<Unauthorized />)
    }

    return (
        <div style={{ padding: '20px'}}>
            <h1>Reports</h1>
            <div>
                <PaginatedList />
            </div>
        </div>
    )
}

export default ReportsScreen